import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useIsAuthenticated } from "../../../hooks/useIsAuthenticated";
export const LoginGuard = (props) => {
    const { redirectTo, loader } = props;
    const [isLoading, isAuthenticated] = useIsAuthenticated();
    return (React.createElement(React.Fragment, null,
        isLoading && loader,
        !isLoading && isAuthenticated && (React.createElement(Navigate, { to: { pathname: redirectTo } })),
        !isLoading && !isAuthenticated && React.createElement(Outlet, null)));
};
